let splitUrl = window.location.pathname.split("/");
let clientId = splitUrl[1];
let userId = splitUrl[2];

const ADMIN_KEY = "app.adminURL";
const REPORT_KEY = "app.reportingURL";

export const UrlInfo = {
  clientId: clientId,
  userId: userId
}

let ANALYTICS_CONFIG = {[ADMIN_KEY]: "", [REPORT_KEY]: ""};

// URL origin of AZURE Function
var ANALYTICS_FUNC_URL = getOriginURL(process.env.REACT_APP_ANALYTICS_FUNC_ORIGIN);

var URLSearchParams = require('url-search-params');
// usage tracking via Google Universal Analytics
export const TRACK_USAGE = (process.env.REACT_APP_TRACK_USAGE === undefined) ?
  false : JSON.parse(process.env.REACT_APP_TRACK_USAGE);

// URL origin of reporting server, set by environment variable but can be overridden by setOriginUrls()
export let REPORT_ORIGIN = getOriginURL(process.env.REACT_APP_REPORT_ORIGIN );

// URL origin of admin (trs) server, set by environment variable but can be overridden by setOriginUrls()
export let ADMIN_ORIGIN = getOriginURL(process.env.REACT_APP_ADMIN_ORIGIN);

// analytics related controllers on the server are gathered under this @RequestMapping prefix
export const REPORT_PREFIX = 'analytics/' + clientId;

// user settings controllers on the server is under this @RequestMapping prefix
export const ADMIN_USER_SETTING_PREFIX = 'api/rest/' + clientId + '/userSetting.ot';

// client settings controllers on the server is under this @RequestMapping prefix
export const ADMIN_CLIENT_SETTING_PREFIX = 'api/rest/' + clientId + '/clientSetting.ot';

// production settings controllers on the server is under this @RequestMapping prefix
export const ADMIN_PRODUCTION_SETTING_PREFIX = 'api/rest/' + clientId + '/productionSetting.ot';

//check if value from pipeline is undefined
function getOriginURL(e){
  if(e === undefined) {
    console.error(`${e} env variable doesn't exist`);
    return "";
  }
  return `${e}`;
}

//retrieve analytics config json
export async function getAnalyticsConfigJSON() {
  const response = await fetch(ANALYTICS_FUNC_URL, {
    method: 'GET',
  });
  let json = await response.json();
  return json;
};

export function setAnalyticsConfig(json) {
  Object.entries(json).forEach(([k, v]) => {
    Object.entries(v).forEach(() => {
      if (ANALYTICS_CONFIG.hasOwnProperty(v.key)) {
        ANALYTICS_CONFIG[v.key] = v.value;
      }
    });
  });
}

//set origin urls to the fetched values if they arent empty
export function setOriginUrlstoConfig () {
  if(ANALYTICS_CONFIG[REPORT_KEY]) {
    REPORT_ORIGIN = ANALYTICS_CONFIG[REPORT_KEY];
  }
  else{
    console.error("REPORT_ORIGIN is empty");
  }
  if(ANALYTICS_CONFIG[ADMIN_KEY]){
    ADMIN_ORIGIN = ANALYTICS_CONFIG[ADMIN_KEY];
  }
  else{
    console.error("ADMIN_ORIGIN is empty");
  }
}

// sets URL origins with document location parameter overrides if provided
export const setOriginUrls = () => {
  let params =new URLSearchParams(document.location);
  let adminHostUrl = params.get('adminHostUrl');
  if (adminHostUrl !== null) ADMIN_ORIGIN = adminHostUrl;
  let reportingHostUrl = params.get('reportingHostUrl');
  if (reportingHostUrl !== null) REPORT_ORIGIN = reportingHostUrl;
};

// creates a URL string given an origin and url (path & query string)
export const createUrlWithOrigin = (origin, url) => {
  origin = (origin === undefined) ? REPORT_ORIGIN : origin;
  return `${origin}/${url}`;
};
export const ServerUrls = {
  Pendo: {
    getTrackingData: `${REPORT_PREFIX}/trackingData`
  },
  Productions: {
    getAll: `${REPORT_PREFIX}/series`,
    getOneSummary: (productionId) => `${REPORT_PREFIX}/series/summary?productionId=${productionId}`,
  },
  Series: {
    getTicketRevenueGoal: (productionId) => `${REPORT_PREFIX}/series/ticketRevenueGoal?productionId=${productionId}`,
    getTicketRevenue: (productionId) => `${REPORT_PREFIX}/series/revenue?productionId=${productionId}`,
    getTicketQuantitySoldGoal: (productionId) => `${REPORT_PREFIX}/series/ticketQuantitySoldGoal?productionId=${productionId}`,
    getTicketQuantitySold: (productionId) => `${REPORT_PREFIX}/series/ticketQuantitySold?productionId=${productionId}`,
    getRevenueData: (productionId) => `${REPORT_PREFIX}/series/data/totalRevenue?productionId=${productionId}`,
    getRevenueDataForDateRange: (productionId,startDate,endDate) => `${REPORT_PREFIX}/series/data/totalRevenue?productionId=${productionId}&startDate=${startDate}&endDate=${endDate}`,
    getSalesData: (productionId) => `${REPORT_PREFIX}/series/data/ticket?productionId=${productionId}`,
    getSalesDataForDateRange: (productionId,startDate,endDate) => `${REPORT_PREFIX}/series/data/ticket?productionId=${productionId}&startDate=${startDate}&endDate=${endDate}`,
    getSeriesComparisonData: () => `${REPORT_PREFIX}/series/data/seriesComparison`,
    getDnDTableData: (productionId, date) => `${REPORT_PREFIX}/series/buckets?productionId=${productionId}&date=${date}`,
    addDnDTableData: (productionId) => `${REPORT_PREFIX}/series/buckets/add?productionId=${productionId}`,
    updateDnDTableData: (productionId) => `${REPORT_PREFIX}/series/buckets/update?productionId=${productionId}`,
    deleteDnDTableData: (productionId) => `${REPORT_PREFIX}/series/buckets/delete?productionId=${productionId}`,
    saveTicketRevenueGoal: (productionId, value) => `${ADMIN_PRODUCTION_SETTING_PREFIX}?productionId=${productionId}&name=seriesRevenueGoal&key=${productionId}&value=${value}`,
    saveTicketQuantitySoldGoal: (productionId, value) => `${ADMIN_PRODUCTION_SETTING_PREFIX}?productionId=${productionId}&name=seriesTicketQuantitySoldGoal&key=${productionId}&value=${value}`
  }
}



// WEBPACK FOOTER //
// ./src/actions/config.js